import {
  AfterViewChecked,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import {Cohort} from "../../model/cohort";
import {TrialProfile} from "../../model/trialprofile";
import {DragulaService} from "ng2-dragula";

@Component({
  selector: 'gen-trial-editor',
  templateUrl: './trial-editor.component.html',
  styleUrls: ['./trial-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrialEditorComponent implements OnChanges, AfterViewChecked, OnInit, OnDestroy {

  @Input() trial: any;

  // initialize the base number (as current time milliseconds) for generating unique object's ID
  private static baseIdCounter: number = performance.now();
  public listName: string = undefined;
  private disableCount: number = 0;
  private isCohortAdded: boolean = false;

  constructor(private dragulaService: DragulaService) {
  }

  ngOnInit() {
    // set a unique list's name to ensure no duplications in dragulaService's bag list
    if (!this.listName) {
      this.listName = 'cohort_items_' + TrialEditorComponent.baseIdCounter++;
    }

    // to use the dragulaService, it is required to call the setOptions method, specifying the container and providing
    // an object literal with your desired options
    if (! this.dragulaService.find(this.listName)) { // need to search first that name is not already added to avoid an error
      this.dragulaService.setOptions(this.listName, {
        moves: (element, container, handle) => {
          return (handle.className.startsWith('fa fa-bars') && this.isDraggable());
        }
      });
    }

  }

  ngAfterViewChecked() {
    const element = document.querySelector('.add-cohort-button');
    if (element && this.isCohortAdded) {
      element.scrollIntoView({behavior: 'smooth'});
      this.isCohortAdded = false;
    }
  }

  ngOnDestroy(): void {
    // remove the current list from the dragulaService's bag list
    if (this.dragulaService.find(this.listName)) { // need to search first that name exists to avoid an error
      this.dragulaService.destroy(this.listName);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.trial && !this.trial.profile) {
      if (this.trial.cohorts && this.trial.cohorts.length > 0) {
        // retrieve from previous location
        this.trial.profile.cohorts = this.trial.cohorts;
      }
      delete this.trial.cohorts;
    }
  }

  private initializeTrialProfile() {
    if (this.trial && !this.trial.profile) {
      // Create an initial trial profile
      this.trial.profile = new TrialProfile();
    }
  }

  private addArms() {
    let arms = this.trial.clinical_study.arm_group;
    if (arms instanceof Array) {
      for (let i = 0; i < arms.length; i++) {
        this.addArm(arms[i]);
      }
    }
    else {
      this.addArm(arms);
    }
  }

  private addArm(arm: any) {
    let cohort = new Cohort();
    cohort.name = '';

    if (arm.arm_group_type) {
      cohort.name = arm.arm_group_type._text + ': ';
    }
    if (arm.arm_group_label) {
      cohort.name = cohort.name + arm.arm_group_label._text;
    }
    if (!this.trial.cohorts) {
      this.trial.cohorts = [];
    }
    this.trial.profile.cohorts.push(cohort);
  }

  addCohort(): void {
    this.initializeTrialProfile();
    this.trial.profile.cohorts.push(new Cohort());
    this.isCohortAdded = true;
  }

  initializeCohortList(): void {
    this.initializeTrialProfile();
    this.addArms();
  }

  cloneCohort(cohort: Cohort) {
    let k = this.trial.profile.cohorts.indexOf(cohort);
    let newCohort = JSON.parse(JSON.stringify(cohort));
    this.trial.profile.cohorts.splice(k, 0, newCohort);
  }

  deleteCohort(cohort: Cohort) {
    this.trial.profile.cohorts = this.trial.profile.cohorts.filter(x => x != cohort);
    //we now have one less cohort in edit mode, so...
    this.enableDraggable(true);
  }

  noCohorts(): boolean {
    let noCohorts:boolean = true;
    if (this.trial && this.trial.profile) {
      noCohorts = this.trial.profile.cohorts.length === 0;
    }
    return noCohorts
  }

  enableDraggable(enable: boolean) {
    if (enable) {
      this.disableCount--;
    }
    else {
      this.disableCount++;
    }
  }

  isDraggable(): boolean {
    return (this.disableCount === 0);
  }

  hasArms(): boolean {
    let arms = this.trial.clinical_study.arm_group;
    if (!arms) {
      return false;
    }
    if (arms instanceof Array) {
      return (arms.length > 0);
    }
    else {
      return true;
    }
  }

  noCohortsAndHasArms(): boolean {
    return (this.noCohorts() && this.hasArms());
  }

}

